import { render, staticRenderFns } from "./rechargeDetail.vue?vue&type=template&id=6d5522a8&"
import script from "./rechargeDetail.vue?vue&type=script&lang=js&"
export * from "./rechargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./rechargeDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports